export function formatBrazilianPhone(phoneString: string): string {
  if (!phoneString) return "";

  return phoneString
    .split(";")
    .filter((phone) => phone.trim() !== "")
    .map((phone) => {
      const cleaned = phone.replace(/\D/g, ""); // Remove não-dígitos

      // Celular com DDD e 9 (11 dígitos)
      if (cleaned.length === 11) {
        return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
      }
      // Celular/Fixo com DDD sem 9 (10 dígitos)
      else if (cleaned.length === 10) {
        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
      }
      // Retorna sem formatação se não for número brasileiro válido
      return phone;
    })
    .join(" ");
}

export function formatCNPJ(value: string): string {
  const regexCNPJ = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
  const numerosCNPJ = value.replace(/\D/g, "");

  if (numerosCNPJ.length !== 14) {
    return value;
  }
  return numerosCNPJ.replace(regexCNPJ, "$1.$2.$3/$4-$5");
}
